<template>
    <div class="envelope-status-summary">
        <div class="flex flex-col gap-4">
            <div class="flex-1">
                <div class="flex items-center">
                    <div class="text-sm">
                        <div v-if="envelope_completed_at"
                            class="text-blue-600 text-base"
                        >
                            Completed on <span class="font-semibold">{{ completed_at_date_formatted_date }}</span>
                            at <span class="font-semibold">{{ completed_at_date_formatted_time }}</span>
                        </div>

                        <div v-else-if="envelope_sent_at"
                            class="text-green-warm-700 text-base"
                        >
                            Sent on <span class="font-semibold">{{ sent_at_date_formatted_date }}</span>
                            at <span class="font-semibold">{{ sent_at_date_formatted_time }}</span>
                        </div>

                        <div v-else
                            class="text-xs text-gray-600"
                        >
                            <span class="text-green-warm-700 font-semibold text-lg">Draft, not sent</span>

                            <div v-if="read_only">Only the envelope owner can edit or send this envelope.</div>

                            <div v-else-if="! has_documents && ! has_recipients">
                                To send this envelope for signatures, add one or more documents and signers.
                            </div>

                            <div v-else-if="! has_documents">
                                To send this envelope for signatures, add one or more documents.
                            </div>

                            <div v-else-if="! has_recipients">
                                To send this envelope for signatures, add one or more signers.
                            </div>

                            <div v-else>
                                Click <span class="text-blue-600 font-semibold">Send for Signatures</span> to add signature fields to your documents and send the envelope with Docusign.
                            </div>
                        </div>
                    </div>

                    <div v-if="fetching"
                        class="ml-3"
                    >
                        <i class="text-green-warm-500 text-sm fas fa-spin fa-sync" aria-hidden="true" />
                    </div>
                </div>
            </div>

            <div v-if="!read_only && ! envelope_sent_at && ! envelopes_available"
                class="flex-none"
            >
                <div class="flex flex-1">
                    <div class="flex flex-col items-end">
                        <p class="text-sm text-blue-600 font-semibold mb-2">
                            To send this envelope, purchase additional Docusign credit.
                        </p>

                        <button type="button" class="envelope-button" @click="purchaseDocusignCredit">
                            Purchase Docusign Credit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonBlue from '../../../components/button-blue.vue';
import ButtonBlueOutline from '../../../components/button-blue-outline.vue';

export default {
    components: {
        ButtonBlue,
        ButtonBlueOutline,
    },

    props: {
        read_only: { default: false },
        envelope: {},
        envelopes_available: {},
        signature_purchase_route: {},
        has_documents: {},
        has_recipients: {},
    },

    data() {
        return {
            fetching: false,
            envelope_status: this.envelope.status,
            envelope_sent_at: this.envelope.sent_at,
            envelope_completed_at: this.envelope.completed_at,
        }
    },

    computed: {
        sent_at_date_formatted_date() {
            return this.envelope_sent_at ? dayjs(this.envelope_sent_at).format('M/D/YYYY') : null;
        },
        sent_at_date_formatted_time() {
            return this.envelope_sent_at ? dayjs(this.envelope_sent_at).format('h:mm A') : null;
        },
        completed_at_date_formatted_date() {
            return this.envelope_completed_at ? dayjs(this.envelope_completed_at).format('M/D/YYYY') : null;
        },
        completed_at_date_formatted_time() {
            return this.envelope_completed_at ? dayjs(this.envelope_completed_at).format('h:mm A') : null;
        },
    },

    methods: {
        getEnvelopeStatus() {
            this.fetching = true;

            axios.get(this.envelope.status_route)
                .then(response => {
                    this.envelope_status = response.data.status;
                    this.envelope_sent_at = response.data.sent_at;
                    this.envelope_completed_at = response.data.completed_at;
                    this.$emit('recipientStatusUpdated', response.data.signers);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(error => {
                    this.fetching = false;
                });
        },
        purchaseDocusignCredit() {
            window.location.href = this.signature_purchase_route;
        },
    },

    created() {
        if (this.envelope.sent_at && ! this.envelope.completed_at) {
            this.getEnvelopeStatus();
        }
    },
}
</script>
